import Query from '../utils/Query';
import Link from '../models/Link';

export default class LinkService {

	static generate(type, meta) {

		const link = new Link({
			type,
		}).flat();

		link.meta = meta;

		return Query.post('/items/link', link, false, undefined).then(response => {
			return new Link(response.data);
		});
	}

	static get(hash) {
		return Query.get('/items/link?filter[hash]=' + hash + '&single=1').then(response => {
			return new Link(response.data);
		});
	}
}
